module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Sending-6249b09931d9806485166554506a68ed.svg";